import styled, {css} from "styled-components";
import React, {useState, useEffect, useRef} from "react";
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper/BreakpointHelper";
import {FormCounter} from "./Counter";

export const PseudoSelect = ({label = 'Persons', placeHolder = "Select", isOpen = false, counterCallback, initialAdult = 1, initialInfant = 0, initialChildren = 0}) => {
    const [hasOpen, setHasOpen] = useState(isOpen);
    const totalCount = initialAdult+initialInfant+initialChildren;
    const selectRef = useRef(null);
    useEffect(() => {
        document.addEventListener('mousedown', handleClickListener);

        return () => {
            document.removeEventListener('mousedown', handleClickListener);
        };
    }, []);

    const handleClickListener = (event) => {
        const clickedInside = (selectRef && selectRef.current.contains(event.target))
        if(!clickedInside) {
            setHasOpen(false);
        }
    }
    return (
        <RefWrapper ref={selectRef}>
            <SelectLabel>{label}</SelectLabel>
            <Wrapper onClick={() => setHasOpen(!hasOpen)}>
                <InnerText>{totalCount}</InnerText>
                <IconWrapper invert={hasOpen}>
                    <i className="fas fa-chevron-down" aria-hidden="true"></i>
                </IconWrapper>
            </Wrapper>
            {hasOpen ? <Card>
                <FormCounter label={'Aikuisia per huone'} margin="16px" initialCount={initialAdult} counterCallback={counterCallback} name="adults" minAmount={1}/>
                <FormCounter label={'Lapsi'} margin="16px" additionalLabel="1 - 12 vuotiaa" initialCount={initialInfant} counterCallback={counterCallback} name="children"/>
                <FormCounter label={'Vauva'} margin="16px" additionalLabel="0 - 1 vuotiaat" initialCount={initialChildren} counterCallback={counterCallback} name="infant"/>
            </Card> : null}
        </RefWrapper>
    )
}

export const RefWrapper = styled.div`display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 305px;
    row-gap: 8px;
    
    ${media.lessThan(breakpoints.mobile)`
        max-width: 100%;
    `}
`;

export const SelectLabel = styled.label`
  font-weight: 600;
`;

export const Wrapper = styled.div`
    display: flex;
    border: 0.063rem solid #949494;
    border-radius: 24px;
    color: #000;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    padding: 0 20px;
    font-family: "museo-sans";
    &:hover {
        cursor: pointer;
    }
`;

export const IconWrapper = styled.span`
    ${({ invert }) => invert &&
    css`
        transform: rotate(180deg);
  `}
`;

export const InnerText = styled.div``;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    background: #fff;
    z-index: 1;
    color: #000;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.06);
    top: 85px;
    
    ${media.lessThan(breakpoints.mobile)`
        width: 100%;
    `}
`;
